<template>
    <div v-if="pending">
        <div class="d-flex justify-content-center loading-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
	<div v-else class="container py-5">
        <h2>{{ $t('parameterDetail') }}</h2>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <RouterLink to="/modelings">
                        {{ $t('home') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">
                    <RouterLink :to="{ name: 'modeling', params: { id: this.$route.params.id } }">
                        {{ modelingName || $t('modelings') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">
                    <RouterLink :to="'/modeling/'+ this.$route.params.id + '/assettype/' + this.$route.params.assetTypeId" >
                        {{ assetTypeName || $t('assetType') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">{{ data.name }}</li>
            </ol>
        </nav>
        <h3 class="text-center mb-4">{{ data.name }} 
            <RouterLink :to="'/modeling/' + this.$route.params.id + '/assettype/' + this.$route.params.assetTypeId + '/parameter/' + this.$route.params.parameterId + '/parameterinfo' ">
                <button class="btn btn-secondary float-end">
                    {{ $t('detail') }}
                </button>
            </RouterLink>
        </h3>
        <div class="mb-3 col-sm-3 ms-auto me-auto">
            <div class="card text-center">
                <div class="card-body">
                    <h5 class="card-title">{{ $t("evaluation") }}</h5>
                </div>
                <ul class="list-group list-group-flush" v-if="evaluationList.length >= 0"> 
                    <li class="list-group-item" v-for="(item, i) in evaluationList" :key="i">
                        <RouterLink :to="'/modeling/' + this.$route.params.id +  '/assettype/'+ this.$route.params.assetTypeId + '/parameter/' + this.$route.params.parameterId + '/evaluation/' + item.id ">
                            {{ item.name || item.id }}
                        </RouterLink>
                    </li>
                </ul>
                <div class="card-body">
                    <RouterLink :to="'/modeling/' + this.$route.params.id + '/assettype/'+ this.$route.params.assetTypeId + '/parameter/' + this.$route.params.parameterId + '/evaluationcreate' ">
                        <button class="btn btn-sm btn-light">{{ $t('addEvaluation')}}</button>
                    </RouterLink>
                </div>
            </div>
        </div>
        <div class="d-grid gap-2 d-md-flex ">
            <button type="button" class="btn btn-secondary" @click="$router.push({ path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}` })">{{ $t('back') }}</button>
        </div>
        <ParameterDeleteModal v-if="showParameterDeleteModal" @reload="$router.push({ path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}` })" @closeDeleteDialog="showParameterDeleteModal = false"/>
    </div>
</template>

<script>
import ParameterApi from "../../api/server/parameter";
import DatasetApi from "../../api/server/dataset";
import AssetTypeApi from "../../api/server/assetType";
import ParameterDeleteModal from '../parameters/ParameterDeleteModal.vue';
import ModelingApi from "../../api/server/modeling";
import { CheckIfUserIsEditor } from '../../authCache';

export default {
    name: "parameterdetail",
    watch: {
        $route: "requestData",
    },
    components: {
        ParameterDeleteModal,
    },
    mounted() {
        this.requestData();
    }, 
    methods: {
        async requestData() {
            this.pending = true;
            this.isUserAdmin = await CheckIfUserIsEditor();

            this.data = await ParameterApi.parameterDetail(this.$route.params.id, this.$route.params.parameterId);
            var assetType = await AssetTypeApi.assetTypeDetail(this.$route.params.id, this.$route.params.assetTypeId);
            this.assetTypeName = assetType.name;

            this.evaluationList = await ParameterApi.evaluationList(this.$route.params.id, this.$route.params.parameterId);
            // this.evaluationList = evaluationList.filter(e => e.parameterId == this.$route.params.parameterId);
       
            var dataset = await DatasetApi.datasetDetail(this.$route.params.id, assetType.datasetId);
            var datasetContent = JSON.parse(dataset.content);
            this.datasetHeaders = datasetContent["headers"];

            var modeling = await ModelingApi.modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;

            for(var i in this.costFactors) {
                var attr = this.costFactors[i];
                if(this.datasetHeaders.findIndex(d => d.name == attr) < 0 && this.missingDatasetHeaders.findIndex(d => d.name == attr) < 0) {
                    this.missingDatasetHeaders.push({ name: attr, alias: attr });
                }
            }

            this.pending = false;
        },
        isFormValid() {
            for(var i in this.costFactors) {
                var attr = this.costFactors[i];
                if(this.datasetHeaders.findIndex(d => d.name == attr) < 0 && attr != "")
                    return false;
            }

            return true
        },
        showDeleteParameter() {
            this.parameterToDeleteId = this.data.id;
            this.showParameterDeleteModal = true;
        },
        removeParameterClass(rowIndex) {
            this.data.parameterClasses.splice(rowIndex, 1);
        },
        addParameterClass() {
            this.data.parameterClasses.push({  
                color: "#000000",
                name: "",
                startClassification: this.getMinStartParameterClass(),
                endClassification: 0.0
            })
        },
        updateParameterClassStart(value, i) {
            var range = this.data.parameterClasses[i+1];
            if(range) {
                range.startClassification = value;
            }
        },
        getMinStartParameterClass() {
            var minStartParameterClass = 0;
            if(this.data.parameterClasses.length > 0)
            minStartParameterClass = this.data.parameterClasses[this.data.parameterClasses.length -1].endClassification;

            return minStartParameterClass;
        }
    },
    notifications: {
        showSuccess: { 
            title: 'success',
            message: 'parameterUpdated',
            type: 'success'
        },
        showWarning: {
            title: 'warning',
            message: 'warningAttributeRemoved',
            type: 'warn'
        },
        showEmptyNameError: { 
            title: 'error',
            message: 'emptyName',
            type: 'error'
        }
    },
    data() {
        return {
            costFactors: [],
            missingDatasetHeaders: [],
            datasetHeaders: [],
            evaluationList: [],
            data: {
                name: "",
                id: ""
            },
            showParameterDeleteModal: false,
            parameterToDeleteId: 0,
            modelingName: null,
            assetTypeName: null,
            pending: true,
            isUserAdmin: false
        }
    }
};
</script>